import { render } from "./AuthHeader.vue?vue&type=template&id=5729e061&scoped=true"
import script from "./AuthHeader.vue?vue&type=script&lang=js"
export * from "./AuthHeader.vue?vue&type=script&lang=js"

import "./AuthHeader.vue?vue&type=style&index=0&id=5729e061&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5729e061"]])

export default __exports__